import xhrService from '../xhrService';

const baseUrl = '/api/projects';

export type InspectionTemplateValidation = {
  is_primary: boolean;
  doc_type_id: number;
};

export const inspectionTemplateValidationApi = {
  /**
   * Validates the inspection template for a specific upload/map
   * @param projectId - The project ID
   * @param uploadGuid - The upload GUID (map ID)
   * @returns Promise with validation result including template type
   */
  validate: async (
    projectId: number,
    uploadGuid: string,
  ): Promise<InspectionTemplateValidation> => {
    return xhrService
      .get(`${baseUrl}/${projectId}/uploads/${uploadGuid}/inspection-template-validation`)
      .then((response) => response.data);
  },
};

export default inspectionTemplateValidationApi;
